import type { JSX } from "react";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";

export function ContactUs(): JSX.Element {
    return (
        <div className="h-full w-full flex flex-col p-8">
            <div className="h-10 md:h-16"></div>
            <div className="h-full w-full card grid grid-rows-4 justify-center items-center p-4">
                <div className="row-span-1 text-4xl sm:text-6xl font-bold p-8">
                    Contact Us
                </div>

                <div className="row-span-2 w-full sm:w-sm">
                    <Panel header="Email">
                        <div className="flex flex-row gap-2 justify-center items-center">
                            <Button icon="pi pi-at" />
                            qubee.electronics@gmail.com
                        </div> 
                    </Panel>
                </div>
            </div>
        </div>
    )
}